require('./dist/infotip/infotip.css');
